<template>
    <div id="calendar">
        <Month class="month"
            v-for="month_tuple in month_tuples"
            :month="month_tuple.month"
            :year="month_tuple.year"
            :tasks="tasks"
        />
    </div>
</template>

<script>
import Month from './Month.vue'

export default{
     name: 'Calendar',
     components: { Month },
     props: {
         tasks: Array,
         range: Number,
         year: Number,
     },
     computed: {
         month_tuples() {
             let year = this.year
             let current_month = new Date().getMonth()+1
             let month_tuples = []

             if(this.range==1){ current_month = 12}

             for(let i=current_month; month_tuples.length<12; i--) {
                 if(i<=0) {i=12; year--}
                 month_tuples.push({
                     month: i,
                     year: year
                 })
             }

             return month_tuples
         }
     }
}
</script>

<style>
 #calendar{
     display: grid;
     height: 100vh;
     grid-template-columns: repeat(4, 1fr);
     grid-template-rows: repeat(3, 1fr);
     padding: 0.5em;
}
.month{
    background: #EEE;
    padding: 0.5em;
    margin: 0.5em;
}

@media screen and (max-width:480px) {
    #calendar{
        grid-template-columns: 1fr;
    }
}
</style>
